<div class="refresh-countdown text-muted">
  <span *ngIf="show">{{busy ? ('Refreshing'|i18n) : ('Refreshing in {0} seconds'|i18n:countdown)}}...</span>
</div>
